// extracted by mini-css-extract-plugin
export default {"dialog":"MatchDialog_dialog__vGumL","select":"MatchDialog_select__+Pj-E"};